import { render, staticRenderFns } from "./CrossBorderEcommerce.vue?vue&type=template&id=4689b9f1&scoped=true"
import script from "./CrossBorderEcommerce.vue?vue&type=script&lang=js"
export * from "./CrossBorderEcommerce.vue?vue&type=script&lang=js"
import style0 from "./CrossBorderEcommerce.vue?vue&type=style&index=0&id=4689b9f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4689b9f1",
  null
  
)

export default component.exports